import React from 'react'
import styles from './style'

const TicketNotFound = () => (
  <div style={styles.container}>
    <div style={{ ...styles.error }}>404</div>
    <div style={{ ...styles.tagLine1 }}>No Conversation found</div>
    <div style={{ ...styles.tagLine2 }}>
      This conversation does not exist or has been deleted.
    </div>
  </div>
)

export default TicketNotFound
